import { getGatewayTransport } from '~/apis/gatewayTransport'

import { createCallCenterUserAgentsClient } from '@mangovoice/cx-call-center-user-agents-client'

export const getCcuaClient = () =>
  createCallCenterUserAgentsClient(getGatewayTransport())
